import { render, staticRenderFns } from "./Revenues.vue?vue&type=template&id=744e6189&scoped=true"
import script from "./Revenues.vue?vue&type=script&lang=ts"
export * from "./Revenues.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e6189",
  null
  
)

export default component.exports